import React from 'react';
import Spinner from 'components/base/Spinner';
import PageError from '../PageError';

type Props = {
    isLoading: boolean;
    timedOut: boolean;
    pastDelay: boolean;
    error: string;
};

export default function PageLoading(props: Props): JSX.Element {
    if (props.isLoading) {
        if (props.timedOut) {
            return (
                <main>
                    <p className='text-center'>
                        Sorry! There seems to be some issue. Please try reloading the page.
                    </p>
                </main>
            );
        } else if (props.pastDelay) {
            return (
                <main>
                    <div className='loading-container text-center'>
                        <Spinner useDefaultColor={true} size={30} />
                    </div>
                </main>
            );
        } else {
            return <main />;
        }
    } else if (props.error) {
        return (
            <main>
                <PageError />
            </main>
        );
    } else {
        return <main />;
    }
}
